import React from 'react';
import { motion } from 'framer-motion';

function PageHeader({ title, subtitle, eyebrow, action, icon: Icon, className = '', showDivider = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={`min-w-0 space-y-4 ${className}`}
    >
      <div className="flex min-w-0 flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div className="flex min-w-0 items-start gap-4">
          {Icon && (
            <div className="icon-tile h-12 w-12 from-orange-500 to-amber-500 shadow-soft">
              <Icon className="h-6 w-6 text-white" strokeWidth={1.75} />
            </div>
          )}
          <div className="min-w-0 space-y-1">
            {eyebrow && <p className="eyebrow">{eyebrow}</p>}
            <h2 className="text-xl font-bold tracking-tight text-secondary-900  lg:text-2xl lg:text-[1.65rem]">
              {title}
            </h2>
            {subtitle && (
              <p className="max-w-2xl text-sm leading-relaxed text-secondary-600 ">
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {action && (
          <div className="w-full min-w-0 max-w-full shrink-0 lg:w-auto lg:max-w-none">{action}</div>
        )}
      </div>
      {showDivider && <div className="divider-gradient" aria-hidden="true" />}
    </motion.div>
  );
}

export default PageHeader;
